import {LibraryExportDiffState} from '@packages/systems/libraries';

/** Color map for the Library Export Item review state */
export const BADGE_FOR_ITEM_REVIEW_STATE = {
  [LibraryExportDiffState.conflict]: 'pink',
  [LibraryExportDiffState.removed]: 'yellow',
  [LibraryExportDiffState.changed]: 'primary',
  [LibraryExportDiffState.added]: 'green',
  [LibraryExportDiffState.unchanged]: undefined,
} as const;

/** Text translation map for the Library Export Item review state */
export const TEXT_FOR_ITEM_REVIEW_STATE = {
  [LibraryExportDiffState.conflict]:
    'designer.components.libraries.review-conflict',
  [LibraryExportDiffState.removed]:
    'designer.components.libraries.review-removed',
  [LibraryExportDiffState.changed]:
    'designer.components.libraries.review-changed',
  [LibraryExportDiffState.added]: 'designer.components.libraries.review-added',
  [LibraryExportDiffState.unchanged]: undefined,
} as const;

/** Polling intervals for library background tasks */
export const PUBLISH_LIBRARY_STATUS_POLLING_INTERVAL = 1000;
export const PUBLISH_LIBRARY_STATUS_MAX_TRIES = 30; // 30s

// total time: 430s (7.5min)
export const FETCH_LIBRARY_TASK_MAX_TRIES = 150;
export const FETCH_LIBRARY_TASK_POLLING_INTERVAL = [
  {from: 1, to: 20, interval: 250}, // first 20 tries every 250ms (5s)
  {from: 20, to: 40, interval: 500}, // sequent 20 tries every 500ms (10s)
  {from: 40, to: 60, interval: 1000}, // sequent 20 tries every 1s (20s)
  {from: 60, to: 75, interval: 2000}, // sequent 15 tries every 2s (30s)
  {from: 75, to: 85, interval: 3000}, // sequent 10 tries every 3s (30s)
  {from: 85, to: 95, interval: 4000}, // sequent 10 tries every 4s (40s)
  {from: 95, to: 125, interval: 5000}, // sequent 30 tries every 5s (150s)
  {from: 125, to: FETCH_LIBRARY_TASK_MAX_TRIES, interval: 6000}, // final 25 tries every 6s (150s)
];
